import { SalesforceCloud } from 'constants/salesforce.constants'
import { applications } from 'constants/user/applications'

export const getFrontlineUrlForCloud = (cloud: SalesforceCloud) => {
  return applications.find(app => {
    return app.cloud === cloud && app.name?.toLowerCase().includes('frontline tier 2')
  })?.url
}
